import { Injectable } from '@angular/core';
import { DocumentReference, Firestore } from '@angular/fire/firestore';
import { BaseService, ToastService } from '@services';

import { TeamContact } from './../../../models/team-websites/team-contact';

@Injectable({
  providedIn: 'root',
})
export class TeamContactService extends BaseService<TeamContact> {
  protected readonly documentPath = 'websitesTeamContact';

  constructor(
    protected db: Firestore,
    protected toastService: ToastService
  ) {
    super(db, toastService);
  }
}
